/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Actions_ColInputs */

const en_admin_posts_actions_col = /** @type {(inputs: Admin_Posts_Actions_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const zh_admin_posts_actions_col = /** @type {(inputs: Admin_Posts_Actions_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Admin_Posts_Actions_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_actions_col = /** @type {((inputs?: Admin_Posts_Actions_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Actions_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_actions_col(inputs)
	return zh_admin_posts_actions_col(inputs)
});
export { admin_posts_actions_col as "admin.posts.actions_col" }